import { cn } from '@src/lib/utils';

import { base64ToBlob } from '@shared/util/base64ToBlob';

import PdfJsViewer from './PdfJsViewer';

import { useWindowDimensions } from '@shadcn-features/core';
import { CSSProperties, useEffect, useRef } from 'react';

const PdfFrameViewer = ({
    pdf,
    style,
    className,
}: {
    pdf: string;
    style?: CSSProperties;
    className?: string;
}) => {
    const wrapRef = useRef<HTMLDivElement>(null);
    const frameRef = useRef<HTMLIFrameElement | null>(null);
    const { isMobile } = useWindowDimensions();

    useEffect(() => {
        const frameWrap = wrapRef.current;
        if (pdf) {
            const deleteFrame = frameRef.current;
            if (deleteFrame) {
                deleteFrame.remove();
            }
            let file = '';
            if (pdf.startsWith('blob:')) {
                file = pdf;
            } else {
                try {
                    const blob = base64ToBlob(pdf, 'application/pdf');

                    file = URL.createObjectURL(blob);
                } catch {
                    file = pdf;
                }
            }
            const fileName = 'template.pdf';
            const iframe = document.createElement('iframe');
            frameRef.current = iframe;
            iframe.setAttribute('width', '100%');
            iframe.setAttribute('height', '100%');
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('scrolling', 'no');
            iframe.setAttribute('toolbar', '0');
            iframe.style.width = '100%';
            iframe.style.height = '100%';
            iframe.style.display = 'block';
            iframe.style.border = '0';

            // Native PDF viewer otherwise keeps its default zoom on mobile,
            // creating a horizontal scrollbar for pages wider than viewport.
            iframe.src = isMobile
                ? `${file}#toolbar=0&view=FitH&zoom=page-width`
                : `${file}#toolbar=0`;
            iframe.name = fileName;
            if (frameWrap) {
                frameWrap.appendChild(iframe);
            }
            return () => {
                const deleteFrame = frameRef.current;
                if (deleteFrame) {
                    deleteFrame.remove();
                }
            };
        } else {
            const deleteFrame = frameRef.current;
            if (deleteFrame) {
                deleteFrame.remove();
            }
        }
    }, [isMobile, pdf]);

    if (isMobile) {
        return <PdfJsViewer className={className} pdf={pdf} style={style} />;
    }

    return (
        <div
            ref={wrapRef}
            className={cn('h-full overflow-x-hidden', className)}
            style={{
                flex: 1,
                height: '100%',
                width: '100%',
                minHeight: 0,
                ...style,
            }}
        />
    );
};

export default PdfFrameViewer;
